export class breadcrumbProduct {
  constructor() {
    if ($('div#crumbar-content li:last-child').text() == 'Detail') {
      $('div#crumbar-content li:last-child strong').text($('h1#detail_title').text());

      var DocumentTitle = $(document).prop('title').replace('Detail', $('h1#detail_title').text());
      $(document).prop('title', DocumentTitle);
    }
  }
}
